import { Typography } from 'antd';
import styles from './CardCatalog.module.css';

const { Title, Text } = Typography;

const StatCard = ({ value, label }) => (
    <div className={styles.statCard} style={{
        textAlign: 'center',
        flex: 1,
        backgroundColor: 'white',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        height: '100%',
        borderRadius: '0.40rem',
        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)'
    }}>
        <Title
            level={3}
            className={styles.statNumber}
            style={{
                margin: 0,
                fontWeight: 'bold',
                lineHeight: 1.1,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                color: '#333'
            }}
        >
            {value}
        </Title>
        <Text
            className={styles.statLabel}
            style={{
                textTransform: 'uppercase',
                fontWeight: 'bold',
                lineHeight: 1.2,
                wordBreak: 'break-word',
                hyphens: 'auto',
                overflow: 'hidden',
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                marginTop: '0.2rem',
                color: '#666'
            }}
        >
            {label}
        </Text>
    </div>
);

export default StatCard;
